var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurchaseHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#42057F;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st0",
    cx: 181.3,
    cy: 444.4,
    r: 62
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M380.2,381.7L380.2,381.7c-34.5-3.4-65.1,21.8-68.5,56.2s21.8,65.1,56.2,68.5c4.1,0.4,8.2,0.4,12.2,0 c34.5-3.4,59.7-34,56.2-68.5C433.5,408.2,410,384.7,380.2,381.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M507.9,145.6c-3.1-4.6-8.4-7.3-13.9-7.2h-68.7v-1.2c0-72.8-59.1-131.9-131.9-131.9S161.4,64.4,161.4,137.2 l0,0v1.2h-51.2L92.7,58.8c-1.9-8.1-9.2-13.8-17.4-13.9H0v36.1h60.8l56,257.2c1.5,8.5,8.9,14.6,17.4,14.5h315.2 c8.4,0,15.5-5.8,17.4-13.9l44.6-178.4C512.8,155.3,511.5,149.7,507.9,145.6z M293.3,233c-53,0-95.8-42.8-95.8-95.8 s42.8-95.8,95.8-95.8s95.8,42.8,95.8,95.8C388.9,189.9,346.2,232.6,293.3,233z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M279,139l-33.2-33.8l-25.9,25.3l45.8,46.4c3.3,3.4,7.9,5.4,12.7,5.4c4.7,0.2,9.3-1.5,12.7-4.8l75.9-71.7 l-24.7-26.5L279,139z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurchaseHistory);
export default __webpack_public_path__ + "static/media/PurchaseHistory.0c0f3812cc253a8c4ce557fe3d6c46b8.svg";
export { ForwardRef as ReactComponent };